import { render, staticRenderFns } from "./SetActivityReminder.vue?vue&type=template&id=656ab1de"
import script from "./SetActivityReminder.vue?vue&type=script&lang=js"
export * from "./SetActivityReminder.vue?vue&type=script&lang=js"
import style0 from "./SetActivityReminder.vue?vue&type=style&index=0&id=656ab1de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports